module.exports = __webpack_public_path__ + "static/media/illustration.4a99ed80.png";